import { render, staticRenderFns } from "./TransaccionNoRegistradaDrawer.vue?vue&type=template&id=55ff20f4&scoped=true&"
import script from "./TransaccionNoRegistradaDrawer.vue?vue&type=script&lang=js&"
export * from "./TransaccionNoRegistradaDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TransaccionNoRegistradaDrawer.vue?vue&type=style&index=0&id=55ff20f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff20f4",
  null
  
)

export default component.exports